"use strict";

import _ from "lodash";
import { ENGLISH, SPANISH } from "../../app.constants";
import mixpanel from "mixpanel-browser";

export class StartPaperworkFormService {
    /* @ngInject */
    constructor($timeout, $translate, $window, $q, $document) {
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$window = $window;
        this.$q = $q;
        this.$document = $document;
    }

    normalizeAutocompleteInputs(form) {
        let inputs = form.querySelectorAll("input");
        _.forEach(inputs, function (input) {
            input.setAttribute("autocomplete", "stop-google");
        });
    }

    normalizeAutocompleteByFormId(formId) {
        let svc = this;
        svc.$timeout(function () {
            let form = svc.$document[0].getElementById(formId);
            if (!form) {
                return;
            }

            svc.normalizeAutocompleteInputs(form);
        });
    }

    addAudioLabels(form) {
        let svc = this;
        svc.$timeout(function () {
            let labels = form.querySelectorAll("label");
            let synth = svc.$window.speechSynthesis;
            if (!synth) {
                return;
            }

            let allVoicesObtained = svc.$q.defer();
            let voices = synth.getVoices();
            if (voices.length !== 0) {
                allVoicesObtained.resolve(voices);
            } else {
                synth.addEventListener("voiceschanged", function () {
                    voices = synth.getVoices();
                    allVoicesObtained.resolve(voices);
                });
            }

            function getPreferredVoice(voices, language) {
                let preferences = {};
                preferences[ENGLISH] = ["en-US", "en"];
                preferences[SPANISH] = ["es-MX", "en"];
                for (let lang of preferences[language]) {
                    let voice = _.find(voices, ["lang", lang]);
                    if (voice) {
                        return voice;
                    }
                }
            }

            allVoicesObtained.promise.then(function (voices) {
                let language = svc.$translate.use();
                let voice = getPreferredVoice(voices, language);
                _.forEach(labels, (label) => {
                    let utterance = new svc.$window.SpeechSynthesisUtterance(
                        label.innerText,
                    );
                    utterance.lang = language;
                    utterance.voice = voice;
                    let audioElement = svc.$document[0].createElement("span");
                    audioElement.innerText = "🔊";
                    audioElement.classList.add("audio-label");
                    audioElement.onclick = function () {
                        if (!synth.speaking) {
                            synth.speak(utterance);
                            mixpanel.track("Played simple form label");
                        }
                    };
                    label.appendChild(audioElement);
                });
            });
        });
    }

    prepareSimpleForm(formId) {
        let svc = this;
        svc.$timeout(function () {
            let form = svc.$document[0].getElementById(formId);
            if (!form) {
                return;
            }

            svc.normalizeAutocompleteInputs(form);

            if (form.getAttribute("data-audio-labels-ready") === "true") {
                return;
            }

            form.setAttribute("data-audio-labels-ready", "true");
            svc.addAudioLabels(form);
        });
    }
}
